module.exports = __webpack_public_path__ + "static/media/Froslass_gaussian2.15ccfb08.png";